import type { StyleRule } from '@archipro-design/aria';
import {
    textInputClassName,
    buttonClassName,
    labelClassName,
    pxArrayToRem,
    getScrollbarStyle,
    pxToRem,
} from '@archipro-design/aria';
import { svgIconClassName } from '@fluentui/react-northstar';

export const ShareDesignBoardForm: StyleRule = () => ({
    width: 'fit-content',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',

    webkitUserSelect: 'none' /* Chrome/Safari */,
    mozUserSelect: 'none' /* Firefox */,
    msUserSelect: 'none' /* IE10+ */,

    /* The rule below is not implemented in browsers yet */
    oUserSelect: 'none',

    /* The rule below is implemented in most browsers by now */
    userSelect: 'none',
});

export const InputCol: StyleRule = ({ theme }) => ({
    background: '#f8f9fa',
    alignItems: 'center',
    fontSize: pxToRem(16),
    lineHeight: pxToRem(16),
    maxHeight: pxToRem(134),
    overflowY: 'auto',
    ...getScrollbarStyle(theme, '0'),
    [`& input`]: {
        paddingLeft: pxToRem(12),
        fontSize: `max(16px, ${pxToRem(16)})`,
    },
});

export const PillDivider: StyleRule = () => ({
    marginBottom: pxToRem(7),
});

export const PillDesktop: StyleRule = ({ theme }) => ({
    display: 'flex',
    maxWidth: `calc(100% - ${pxToRem(24)})`,
    width: 'fit-content',
    paddingRight: pxToRem(12),
    paddingTop: pxToRem(10),
    marginBottom: pxToRem(1),
    textOverflow: 'ellipsis',
    marginLeft: pxToRem(12),

    [`& span`]: {
        textOverflow: 'ellipsis',
        display: 'block',
        overflow: 'hidden',
        width: '100%',
    },

    [`& .${svgIconClassName}`]: {
        width: pxToRem(14),
        marginLeft: pxToRem(8),
        top: pxToRem(-4),
        position: 'relative',
        fill: theme.siteVariables.colors.white['FFF'],
        cursor: 'pointer',
    },
});

export const EmailPill: StyleRule = () => ({
    alignItems: 'center',
    background: '#c9c6c6',
    borderRadius: pxToRem(16),
    padding: pxArrayToRem([7, 12]),
});

export const FormInput: StyleRule = () => ({
    display: 'flex',
    flexDirection: 'column',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    fontSize: `max(16px, ${pxToRem(16)})`,
});

export const MessageStyles: StyleRule = (props) => ({
    ...FormInput(props),
    resize: 'none',
    height: pxToRem(117),
    width: '100%',
    paddingTop: pxToRem(17),
    paddingLeft: pxToRem(12),
});

export const EmailStyles: StyleRule = (props) => ({
    ...FormInput(props),
    width: pxToRem(348),
    height: pxToRem(52),
});

export const FormColumn: StyleRule = () => ({
    [`& .${labelClassName}`]: {
        width: pxToRem(100),
        display: 'inline-block',
    },
    [`& .${textInputClassName}`]: {
        width: pxToRem(200),
        display: 'inline-block',
    },
});

export const FormContainer: StyleRule = ({ theme }) => ({
    padding: pxToRem(28),
    paddingTop: pxToRem(65),
    [`& input, textArea`]: {
        backgroundColor: theme.siteVariables.colors.white['000'],
    },
    background: theme.siteVariables.colors.white['FFF'],
});

export const FormHeader: StyleRule = () => ({
    letterSpacing: '-0.02em',
    marginBottom: pxToRem(31),
});

export const EmailInput: StyleRule = () => ({
    height: pxToRem(52),
});

export const CancelButton: StyleRule = ({ theme }) => ({
    borderColor: theme.siteVariables.colors.charcoal['000'],
    [`&> .${buttonClassName}`]: {
        borderColor: theme.siteVariables.colors.charcoal['000'],
    },
});

export const BottomButtons: StyleRule = () => ({
    position: 'relative',
    height: '100%',
    display: 'flex',
    bottom: 0,
    right: pxToRem(1),
    alignItems: 'flex-end',
    alignSelf: 'flex-end',
    [`& > .${buttonClassName}`]: {
        marginLeft: pxToRem(8),
        width: pxToRem(143),
        padding: pxToRem(17.5),
    },
});

export const SocialMediaShareButtonsWrapper: StyleRule = () => ({
    margin: pxArrayToRem([116, 0, 0, -2]),
});

export const ShareForm: StyleRule = () => ({
    height: '100%',
});

export const FormFlex: StyleRule = () => ({
    paddingTop: 0,
    height: '100%',
});

export const ShareModalBottomButtons: StyleRule = () => ({
    marginRight: pxToRem(-32),
});
